import React from 'react';
import { Gift } from 'lucide-react';
const BONUSES = [{
  title: 'BONUS #1: Calendario Productivo Anual',
  value: 'ARS 9.990',
  description: 'Sabé qué plantar cada mes y mantené producción continua todo el año.'
}, {
  title: 'BONUS #2: Fertilizantes Naturales & Bioinsumos',
  value: 'ARS 7.990',
  description: 'Recetas caseras de nutrición real. Sin químicos, sin gastos innecesarios.'
}, {
  title: 'BONUS #3: Mini Invernadero Low Cost',
  value: 'ARS 8.990',
  description: 'Producí fuera de temporada con bajo presupuesto. Paso a paso accesible.'
}];
export function BonusesSection() {
  return <section className="py-10 px-4 bg-zinc-900 relative overflow-hidden" data-id="element-17">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-18">
        <div className="text-center mb-6" data-id="element-19">
          <span className="inline-block bg-red-600 text-white font-bold text-[10px] uppercase px-2.5 py-0.5 rounded-full mb-2 animate-pulse" data-id="element-20">
            Gratis por hoy
          </span>
          <h2 className="text-xl md:text-2xl font-bold text-white" data-id="element-21">
            Además, Llevás Estos Bonos
          </h2>
        </div>

        <div className="space-y-2.5" data-id="element-22">
          {BONUSES.map((bonus, index) => <div key={index} className="bg-black border border-zinc-800 rounded-lg px-4 py-3 flex items-start gap-3" data-id="element-23">
              <div className="bg-green-500 p-1 rounded flex-shrink-0 mt-0.5" data-id="element-24">
                <Gift className="w-3.5 h-3.5 text-black" data-id="element-25" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-26">
                <div className="flex items-baseline justify-between gap-2 flex-wrap" data-id="element-27">
                  <h3 className="text-sm font-bold text-white" data-id="element-28">
                    {bonus.title}
                  </h3>
                  <div className="flex items-center gap-1.5 flex-shrink-0" data-id="element-29">
                    <span className="text-zinc-500 line-through text-xs" data-id="element-30">
                      {bonus.value}
                    </span>
                    <span className="text-green-500 font-bold text-xs" data-id="element-31">
                      GRATIS
                    </span>
                  </div>
                </div>
                <p className="text-gray-400 text-xs mt-0.5" data-id="element-32">
                  {bonus.description}
                </p>
              </div>
            </div>)}
        </div>

        <div className="mt-5 flex justify-center" data-id="element-33">
          <div className="bg-zinc-950 border border-green-500/30 rounded-lg px-5 py-2 text-center" data-id="element-34">
            <p className="text-sm text-white font-medium" data-id="element-35">
              Valor total en bonos:{' '}
              <span className="text-zinc-500 line-through" data-id="element-36">ARS 26.970</span>{' '}
              <span className="text-green-500 font-bold ml-1" data-id="element-37">
                → HOY GRATIS
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}